import { render } from "./receiptItemDisplay.vue?vue&type=template&id=dc588b30"
import script from "./receiptItemDisplay.vue?vue&type=script&lang=js"
export * from "./receiptItemDisplay.vue?vue&type=script&lang=js"

import "./receiptItemDisplay.vue?vue&type=style&index=0&id=dc588b30&scope=true&lang=css"

import exportComponent from "D:\\Programming_And_Stuff\\Programming\\VueJs\\food-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__